import { loadModalError } from './load-modal-error/index.tsx';

export const errors = {
	loadModalError,
};
